<template>
    <v-container fluid>
        <v-row>
        <v-col cols="12">
            <div class="mb-5 mx-auto text-right">
                <v-btn @click="edit()" dark color="primary">
                    <v-icon>mdi-plus</v-icon>
                    New
                </v-btn>
            </div>
            <v-data-table
            v-if="userList"
            :loading="loading" loading-text="Loading... Please wait"
            :headers="headers"
            :items="userList"
            :sort-by="['id']"
            :server-items-length="pagination.count"
            hide-default-footer
            class="elevation-1"
            >
            <template v-slot:item="row">
              <tr>
                <td class="text-left">{{row.item.id}}</td>
                <td class="text-left">{{row.item.username}}</td>
                <td class="text-left">{{row.item.email}}</td>
                <td class="text-left">
                    <span class="comma-separated" v-for="(team ,index) in row.item.team_set" v-bind:key="index">{{ getTeamName(team) }}</span>
                </td>
                <td style="width:150px" class="text-xs-center">
                    <v-btn-toggle>
                        <v-btn small fab icon color="grey"  @click="edit(row.item.id)">
                        <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn small fab icon color="grey" @click="remove(row.item.id)" >
                        <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div class="text-center">
              <v-pagination total-visible="7" class="mt-2 mb-2" v-model="pagination.current" :length="pagination.pages"></v-pagination>
              <div class="subtitle">Total: {{pagination.count}}</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
</template>
<script>
	export default {
		data: () => ({
            headers: [
            { text: 'ID', align: 'left', sortable: true, value: 'id', width: 100},
            { text: 'Username', value: 'username' },
            { text: 'Email', value: 'email' },
            { text: 'Team', value: 'team_set' },
            { text: '', sortable: false,}
            ],
            pagination:{
                count:0,
                pages: 1,
                current:1,
            },
            perPage: 20,
			success: false,
			userList: [],
            loading: true,
		}),
		methods: {
            // Main Function
            list() {
			    this.getUsers(1).then((res) => {
                    this.userList = res.results;
                    this.pagination.next = res.next
                    this.pagination.count = res.count
                    this.pagination.pages = Math.ceil(res.count / this.perPage)
                });
            },
			async getUsers(page) {
                try {
                    this.loading = true
                    const res = await this.$api.user.search({ limit:this.perPage, offset: this.perPage*(page - 1) });
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    this.loading = false
                }
            },
			edit(id) {
                this.$router.push({ name: 'userForm', params: { id } })
            },
            remove(id) {
                this.$swal({
                    icon: 'warning',
                    title: 'Are you sure to delete this?',
                    showCancelButton: true,
                    reverseButtons: true,
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'No',
                }).then((result) => {
                    if (result.value) {
			            this.$api.user.delete(id).then(res => this.list() );
                    }
                })
            },
            getTeamList() {
			    this.getTeams().then(res => this.teamList = res);
            },
			async getTeams() {
                try {
                    this.loading = true
                    const res = await this.$api.team.list();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    this.loading = false
                }
            },
            getTeamName(id) {
                if ( this.teamList.length !== 0 && id ) {
                    return this.teamList.find(team => team.id === id).name;
                }
            }, 
		},
		mounted () {
            this.list();
            this.getTeamList();
            this.success = true;
		},
        watch: {
            pagination: {
                handler(val){
                    this.getUsers(this.pagination.current).then((res) => {
                        this.userList = res.results;
                    });
                },
                deep: true
            },
        },
	}
</script>